module.exports = __webpack_public_path__ + "static/assets/b1306fa1f8be69c789a33cb69710761b.png";